import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import { BsEnvelope, BsTwitter, BsWhatsapp } from "react-icons/bs";

const Share = (props) => {
    if(props.blog){
        const encodedURL = encodeURIComponent(`${window.location.origin}/blog?slug=${props.blog.slug}`);
        const encodedTitle = encodeURIComponent(props.blog.title);

        const twitterShareUrl = `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedURL}`;
        const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedURL}`;
        const linkedinShareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodedURL}&title=${encodedTitle}`;
        const whatsappShareUrl = `https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedURL}`
        
        return (
            <div className='py-4'>
                <h5>Sharing is caring</h5>
                <div className="social-buttons my-4">
                    <div className="products-others-right">
                        <a href={facebookShareUrl} target='_blank' rel='noreferrer' style={{background: "#0E76E6"}}><BsEnvelope /></a>
                        <a href={twitterShareUrl} target='_blank' rel='noreferrer' style={{background: "#0087BA"}}><BsTwitter /></a>
                        <a href={facebookShareUrl} target='_blank' rel='noreferrer' style={{background: "#2D4373"}}><FaFacebookF /></a>
                        <a href={linkedinShareUrl} target='_blank' rel='noreferrer' style={{background: "#005983"}}><FaLinkedinIn /></a>
                        <a href={whatsappShareUrl} target='_blank' rel='noreferrer' style={{background: "#1F7D1E"}}><BsWhatsapp /></a>
                    </div>
                </div>
            </div>
        )
    }else{
        return <h1>Loading...</h1>
    }
}

export default Share